module.exports = __webpack_public_path__ + "static/media/banner_mobil.7e352e6a.png";